import React, { useEffect, useState } from 'react'
import CertificateGenerator from '../../components/CertificateGenerator'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useDispatch, useSelector } from 'react-redux';
import { __hideLoader, __showLoader } from '../../Redux Store/Slices/loader';
import { certificateUrl, courseUrl } from '../../urls';
import moment from 'moment';

const Certificate = () => {
    const params = useParams();
    const id = params.id;
    const errorHandler = useErrorHandler();
    const dispatch = useDispatch();
    const { show } = useSelector(ctx => ctx.loader);

    const [data, setData] = useState({
        "courseEnrollmentId": "",
        "recipientName": "",
        "courseName": "",
        "issuedAt": "",
        tags: [],
        id: '',
        hrs: 0
    });

    useEffect(() => {
        if (id) {
            dispatch(__showLoader("Certificate Loading..."));
            axios.get(certificateUrl + id).then(res => {
                setData({
                    courseEnrollmentId: res.data.courseEnrollment.id,
                    recipientName: res.data.recipientName,
                    courseName: res.data.courseName,
                    courseParentName: res?.data?.courseEnrollment?.course?.name,
                    issuedAt: moment(res.data?.issuedAt).format("DD-MM-YYYY"),
                    tags: res?.data?.courseEnrollment?.course?.tags,
                    hrs: res?.data?.courseEnrollment?.course?.duration,
                    id: res.data?.id,
                    type: res.data?.type
                })
            }).catch(errorHandler).finally(() => {
                dispatch(__hideLoader())
            })
        }
    }, [id]);
    if (!show)
        return (
            <div>
                <CertificateGenerator data={data} showCopyButton />
            </div>
        )
}

export default Certificate